import { render } from "./PdfPageHeader.vue?vue&type=template&id=0ee45437&scoped=true&ts=true"
import script from "./PdfPageHeader.vue?vue&type=script&lang=ts"
export * from "./PdfPageHeader.vue?vue&type=script&lang=ts"

import "./PdfPageHeader.vue?vue&type=style&index=0&id=0ee45437&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee45437"]])

export default __exports__